module.exports = __webpack_public_path__ + "img/icon／2.c9377f50.png";